import { callApi } from 'loankeeper-common/api'

export const view = (params) =>
  callApi('collateral_mng_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const oper = (params) =>
//   callApi('collateral_mng_oper', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const viewSessions = ({ SessionDate }) => view({ action: 'viewsessions', SessionDate })

export const print = ({ CMSessionID, HashSum_CMSessionID_ }) =>
  view({ action: 'printsession', CMSessionID, HashSum_CMSessionID_ })

// export const viewWorklist = ({ CMSessionID, HashSum_CMSessionID_ }) =>
//   view({ action: 'viewworklist', CMSessionID, HashSum_CMSessionID_ })

// export const loadWorklist = ({ CMSessionID, HashSum_CMSessionID_ }) =>
//   oper({ action: 'loadworklist', CMSessionID, HashSum_CMSessionID_ })

// export const clearWorklist = ({ CMSessionID, HashSum_CMSessionID_ }) =>
//   oper({ action: 'clearworklist', CMSessionID, HashSum_CMSessionID_ })

// export const addWorklist = ({ CMSessionID, HashSum_CMSessionID_, CollateralID, HashSum_CollateralID_ }) =>
//   oper({ action: 'addworklist', CMSessionID, HashSum_CMSessionID_, CollateralID, HashSum_CollateralID_ })

// export const deleteWorklist = ({ CMSessionID, HashSum_CMSessionID_, ID }) =>
//   oper({ action: 'deleteworklist', CMSessionID, HashSum_CMSessionID_, ID })

// export const processWorklist = ({ CMSessionID, HashSum_CMSessionID_, StateID, LocationID }) =>
//   oper({ action: 'processworklist', CMSessionID, HashSum_CMSessionID_, StateID, LocationID })
